<script lang="ts" setup>
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import emblaCarouselVue from 'embla-carousel-vue'
const [emblaRef, emblaApi] = emblaCarouselVue({ align: 'start' }, [WheelGesturesPlugin()])

type Media = {
  id: string
  url: string
}

type SpecieGroupCard = {
  value: string
  count: number
}

const _props = defineProps<{ items: SpecieGroupCard[] }>()

const activeIndex = ref(0)

const state = ref({
  canScrollPrev: false,
  canScrollNext: true,
})

onMounted(() => {
  if (emblaApi.value) {
    const togglePrevNextBtnsState = () => {
      state.value.canScrollPrev = emblaApi.value?.canScrollPrev() || false
      state.value.canScrollNext = emblaApi.value?.canScrollNext() || false
      activeIndex.value = emblaApi.value?.selectedScrollSnap() || 0 // Update activeIndex
    }

    emblaApi.value
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  }
})
</script>

<template>
  <div class="">
    <div class="px-bleed mt-7.5 mb-5 flex">
      <div class="flex w-full items-center justify-end">
        <div v-if="items?.length > 4" class="shrink-0">
          <elementsArrowButton
            class="cursor-pointer"
            :class="!state.canScrollPrev ? 'opacity-30' : ''"
            :disabled="!state.canScrollPrev"
            aria-label="Previous slide"
            variant="back"
            @click="() => emblaApi?.scrollPrev()"
          />

          <elementsArrowButton
            class="cursor-pointer"
            :class="!state.canScrollNext ? 'opacity-30' : ''"
            :disabled="!state.canScrollNext"
            aria-label="Next slide"
            @click="() => emblaApi?.scrollNext()"
          />
        </div>
      </div>
    </div>

    <div ref="emblaRef" class="embla documents pl-bleed pr-bleed">
      <div class="embla__container relative z-[2] w-full">
        <article
          v-for="item in items"
          :key="item.value"
          class="font-display mr-10 flex shrink-0 flex-nowrap items-end"
        >
          <span class="mr-2 text-3xl">{{ (item.count || 0).toLocaleString('da-DK') }}</span>
          <span class="text-xl">{{ $t(`arter.${item.value}`) }}</span>
        </article>
      </div>
    </div>
  </div>
</template>

<style scoped>
.embla {
  overflow: hidden;
}
.embla__container {
  display: flex;
  gap: var(--grid-gap);
}

.embla__slide {
  flex: 0 0 85vw;
  min-width: 0;

  @media (min-width: 900px) {
    flex: 0 0 var(--cols-4);
  }
}
</style>
